import React from "react";
var __jsx = React.createElement;
import stl from "./LoadMoreBtn.module.css";
import { useTranslation } from "@i18n";
import { useLocation } from "react-router-dom";
import { isAutosOrYearsOrNewCarsScreen } from "@/pages/search/searchHooks/filtersHelpers";
import WithVisibilityTrigger from "@/common/HOCs/WithVisibilityTrigger";
import { canonicalize } from "@/utils/common";
var LoadMoreBtn = function LoadMoreBtn(_ref) {
  var page = _ref.page,
    showPlaceHolder = _ref.showPlaceHolder;
  var _useTranslation = useTranslation(["web_search"]),
    t = _useTranslation.t;
  var location = useLocation();
  var hasSeoUrl = isAutosOrYearsOrNewCarsScreen(location);
  var buildNewUrl = function buildNewUrl() {
    if (!hasSeoUrl) {
      return '#';
    }
    var searchParams = new URLSearchParams(location.search);
    searchParams.set("page", page + 1);
    return canonicalize("".concat(location.pathname, "?").concat(searchParams.toString()));
  };
  var scrollFewInches = function scrollFewInches() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    e && e.preventDefault();
    window.scrollBy({
      top: -100,
      behavior: 'smooth'
    });
  };
  if (showPlaceHolder) {
    return /*#__PURE__*/React.createElement("div", {
      className: stl.link,
      style: {
        backgroundColor: "inherit"
      }
    });
  }
  var cb = function cb() {
    scrollFewInches();
  };
  return /*#__PURE__*/React.createElement(WithVisibilityTrigger, {
    enabled: true,
    cb: cb
  }, /*#__PURE__*/React.createElement("a", {
    className: stl.link,
    href: buildNewUrl(),
    onClick: scrollFewInches,
    rel: hasSeoUrl ? "canonical" : ""
  }, t("المزيد من السيارات", {
    ns: "web_search"
  })));
};
export default LoadMoreBtn;